import { CSSProperties, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { BadgeDotSize } from './enums';
import { BadgeDot } from './BadgeDot';
import { Icon, IconName, IconSize, SvgImageName } from '@ardoq/icons';
import { StatusType } from '../types';

const Container = styled.div`
  position: relative;
  display: inline-flex;
`;

const IconBadgeIcon = styled(Icon)<{ $iconSize: IconSize }>`
  top: 0;
  left: 0;
  position: relative;
  width: ${({ $iconSize }) => $iconSize}px;
  height: ${({ $iconSize }) => $iconSize}px;
`;

export const ICON_BADGE_ICON_SELECTOR = IconBadgeIcon.toString();

const StyledBadgeDot = styled(BadgeDot)<{ $iconSize: IconSize }>`
  top: -3px;
  left: ${({ $iconSize }) => $iconSize - BadgeDotSize.SMALL / 2}px;
  position: absolute;
`;

interface IconBadgeProperties {
  iconName: IconName | SvgImageName;
  iconSize?: IconSize;
  iconStyle?: CSSProperties;
  statusType: StatusType;
}

export const IconBadge = ({
  iconName,
  iconStyle,
  statusType,
  iconSize = IconSize.LARGE,
  ...rest
}: IconBadgeProperties & HTMLAttributes<HTMLDivElement>) => (
  <Container {...rest}>
    <IconBadgeIcon
      iconSize={iconSize}
      iconName={iconName}
      style={iconStyle}
      $iconSize={iconSize}
    />
    <StyledBadgeDot
      $iconSize={iconSize}
      color={statusType}
      size={BadgeDotSize.SMALL}
    />
  </Container>
);
